import { AssetConfig } from "../index";

export const TanksAssetConfig: AssetConfig = {
    name: {type: "STRING", required: true, editable: true, label: "Name", rank: 1},
    size: {type: "STRING", required: true, editable: true, label: "Size", rank: 3},
    mobileTank: {type: "BOOLEAN", required: true, editable: true, label: "Mobile tank", rank: 4},
    isActive: {type: "BOOLEAN", required: true, editable: true, label: "Active", rank: 5},
    fuelReceiveBulkDelivery: {type: "BOOLEAN", required: true, editable: true, label: "Accept bulk deliveries", rank: 5},
    fuelTypeId: {type: "SELECT", required: true, editable: true, label: "Fuel type", rank: 2},
};